import { Music, Users, Building2, Search, Calendar, Zap } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function BandFindenZuerich() {
  return (
    <SEOLandingPage
      title="Band finden in Zürich | jamnation - Zürcher Bands entdecken"
      description="Entdecke die besten Bands aus Zürich. Live-Bands für Events, Konzerte und Clubs. Rock, Pop, Electronic, Jazz und mehr aus der grössten Schweizer Stadt."
      h1="Band finden in Zürich"
      heroText="Entdecke die pulsierende Bandszene von Zürich. Von etablierten Acts bis zu aufstrebenden Newcomern – finde die perfekte Band für dein Event oder entdecke neue Live-Musik."
      keywords={[
        'band finden zürich',
        'band suchen zürich',
        'zürcher bands',
        'liveband zürich',
        'coverband zürich',
        'partyband zürich',
        'band buchen zürich',
        'musikszene zürich',
      ]}
      locationName="Zürich & Agglomeration"
      ctaButtons={[
        {
          text: 'Zürcher Bands entdecken',
          link: '/bands',
          primary: true,
        },
        {
          text: 'Band buchen',
          link: '/book-band',
        },
      ]}
      features={[
        {
          icon: Building2,
          title: 'Grösste Bandszene',
          description:
            'Zürich bietet die grösste Auswahl an Bands in der Schweiz. Von allen Stadtkreisen bis zur Agglomeration.',
          link: '/bands',
        },
        {
          icon: Zap,
          title: 'Professionelle Acts',
          description:
            'Hochprofessionelle Bands für Corporate Events, Galas und grosse Bühnen. Zürich ist das Zentrum für Top-Acts.',
          link: '/bands',
        },
        {
          icon: Music,
          title: 'Alle Musikstile',
          description:
            'Rock, Pop, Electronic, Hip-Hop, Jazz, Funk, Soul – Zürichs vielfältige Szene deckt jeden Geschmack ab.',
          link: '/bands',
        },
        {
          icon: Calendar,
          title: 'Live-Hotspots',
          description:
            'Von der Roten Fabrik bis zum Kaufleuten – sieh dir an, wo die besten Zürcher Bands live auftreten.',
          link: '/agenda',
        },
        {
          icon: Search,
          title: 'Präzise Suche',
          description:
            'Filter nach Genre, Bandgrösse, Budget und Stadtteil. Finde in Minuten die perfekte Band für dein Event.',
          link: '/bands',
        },
        {
          icon: Users,
          title: 'Direkt buchen',
          description:
            'Kontaktiere Bands direkt ohne Agentur-Provision. Transparente Preise und schnelle Kommunikation.',
          link: '/bands',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation ist die Plattform für die Schweizer Musikszene. Hier findest du nicht nur Bands, sondern kannst auch deine eigene Band präsent machen.',
        items: [
          'Erstelle ein Profil für deine Band mit Fotos und Videos',
          'Veröffentliche deine kommenden Konzerte und erreiche mehr Publikum',
          'Lade Hörproben hoch und zeige, was eure Band drauf hat',
          'Teile Geschichten aus dem Bandalltag mit deinen Fans',
          'Vernetze dich mit anderen Bands und Musikern aus Zürich',
          'Werde für Events, Hochzeiten und Firmenanlässe gebucht',
        ],
      }}
      seoTeaser={{
        title: 'Zürichs vielfältige Bandszene erleben',
        description:
          'Als grösste Stadt der Schweiz bietet Zürich eine unvergleichliche Dichte an Live-Musik. Von der Roten Fabrik über das Kaufleuten bis zum Dynamo – überall pulsiert Live-Musik. Ob du eine professionelle Coverband für deine Hochzeit suchst, eine Corporate-Band für dein Firmenevent brauchst oder einfach neue lokale Musik entdecken möchtest: Auf jamnation findest du hunderte Zürcher Bands aus allen Genres. Mit detaillierten Profilen, Soundbeispielen und direkter Kontaktmöglichkeit wird die Bandsuche zum Kinderspiel. Nutze unsere intelligenten Filter nach Genre, Bandgrösse und Stadtteil, um schnell die perfekte Band zu finden. Unterstütze lokale Musiker und erlebe, was die Zürcher Szene zu bieten hat.',
      }}
      faqItems={[
        {
          question: 'Welche Arten von Bands finde ich in Zürich?',
          answer:
            'In Zürich findest du alles: Von professionellen Corporate-Bands über Cover-Bands für Hochzeiten bis zu Underground-Acts. Die Stadt hat die vielfältigste Szene der Schweiz.',
        },
        {
          question: 'Was kostet eine Band in Zürich?',
          answer:
            'Die Preise variieren stark je nach Erfahrung, Event-Typ und Dauer. Am besten kontaktierst du mehrere Bands für Offerten. Viele sind flexibel bei der Preisgestaltung.',
        },
        {
          question: 'Gibt es auch Electronic-Acts und DJs?',
          answer:
            'Zürich hat eine starke Electronic-Szene. Du findest sowohl Live-Electronic-Acts als auch DJ-Sets für alle Arten von Events.',
        },
        {
          question: 'Wo treten Zürcher Bands normalerweise auf?',
          answer:
            'Beliebte Locations sind Rote Fabrik, Kaufleuten, Dynamo, Mascotte, Komplex 457, Exil und viele mehr. Die Konzertdichte in Zürich ist sehr hoch.',
        },
        {
          question: 'Kann ich Bands für internationale Events buchen?',
          answer:
            'Ja! Viele Zürcher Bands sind international erfahren und spielen regelmässig im Ausland. Sie sind professionell aufgestellt für grössere Events.',
        },
        {
          question: 'Wie kann ich meine Zürcher Band auf jamnation präsentieren?',
          answer:
            'Erstelle ein kostenloses Bandprofil mit Zürich als Standort, lade professionelle Fotos und Soundbeispiele hoch und liste deine kommenden Shows auf.',
        },
      ]}
    />
  );
}
